import { useState } from "react";

function altExtensionUrl(url) {
  if (url.endsWith(".png")) return url.slice(0, -4) + ".jpg";
  if (url.endsWith(".jpg")) return url.slice(0, -4) + ".png";
  return null;
}

// Tour cover photos get uploaded in whichever format is on hand (.png or .jpg) — this <img>
// retries once with the other extension before giving up, instead of silently staying blank
// just because someone uploaded the "wrong" one. Calls onFinalError only once both attempts
// have failed, matching a plain <img onError> caller's expectations.
export function FallbackImage({ src, onFinalError, ...imgProps }) {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [failed, setFailed] = useState(false);

  if (failed) return null;

  const handleError = () => {
    const alt = currentSrc === src ? altExtensionUrl(src) : null;
    if (alt) {
      setCurrentSrc(alt);
    } else {
      setFailed(true);
      onFinalError?.();
    }
  };

  return <img src={currentSrc} onError={handleError} {...imgProps} />;
}
